var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showText==1)?_c('p',[_vm._v("您已领取过证书")]):_vm._e(),(_vm.showText==2)?_c('p',[_vm._v("您还未领取证书")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }